import NTPClient from './ntp-client';

class NearWorldClock {
  #ntpClient = new NTPClient();

  public constructor() {}

  get synced() {
    return this.#ntpClient.ntpNow != null;
  }

  get gapMilliSecondsFromSystemTime() {
    if (!this.synced) return undefined;
    return this.now() - Date.now();
  }

  get() {
    return this.#ntpClient.ntpNow ?? new Date();
  }

  now() {
    return this.get().getTime();
  }
}

export default new NearWorldClock();
